import { Avatar, Box, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import editIcon from "../../assets/images/edit-icon.png";
import Dialog from "../../components/shared/Dialog";
import ProfileForm from "./ProfileForm";
import { find } from "lodash";
import useProfile from "../../data/talons/Profile/useProfile";
import { useSelector } from "react-redux";
import { getUserLoggedInStatus } from "../../data/selectors/Authentication/appState.selector";
import { getProfileData } from "../../data/selectors/Profile/profile.selector";
export default function Profile() {
  const [showDialog, setShowDialog] = useState(false);
  const [editId, setEditId] = useState(null);

  const userSelector = useSelector(getUserLoggedInStatus);
  const { fetchProfileData } = useProfile();
  useEffect(() => {
    fetchProfileData(userSelector?.doctorId);
  }, []);

  const ProfileData = useSelector(getProfileData);

  return (
    <Grid
      container
      //   justifyContent={"center"}
      alignItems={"center"}
      // height={"80vh"}
    >
      {/* <Grid
        item
        xs={6}
        sm={3}
        md={2}
        sx={{ marginLeft: "auto", textAlign: "end" }}
      > */}
      <Dialog
        handleClose={() => {
          setShowDialog(false);
          setEditId(null);
          fetchProfileData(userSelector?.doctorId);
        }}
        open={showDialog}
        fullWidth={true}
      >
        <ProfileForm
          postSubmit={async () => {
            setShowDialog(false);
            setEditId(null);
            await fetchProfileData(userSelector?.doctorId);
          }}
          editId={ProfileData?.id}
          editItem={ProfileData}
        />
      </Dialog>
      {/* </Grid> */}
      <Grid
        item
        xs={12}
        sm={12}
        md={5.5}
        display={"flex"}
        justifyContent={"center"}
      >
        <Avatar
          alt="Remy Sharp"
          src={ProfileData?.image_url}
          sx={{
            height: "300px",
            width: "300px",
            textAlign: "center",
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={5}>
        <Grid
          sx={{
            padding: "10px",
            border: "1px solid",
            borderRadius: "30px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            paddingLeft: { md: "50px", sm: "0px" },
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <IconButton className="iconbtn" onClick={() => setShowDialog(true)}>
              <img style={{ height: "35px", width: "35px" }} src={editIcon} />
            </IconButton>
          </Box>
          <Typography sx={{ lineHeight: "55px" }}>
            <span style={{ fontWeight: "bold" }}>Full Name :</span>{" "}
            <span style={{ marginLeft: "5px" }}>{ProfileData?.name}</span>
          </Typography>
          <Typography sx={{ lineHeight: "55px" }}>
            <span style={{ fontWeight: "bold" }}>Speciality :</span>{" "}
            <span style={{ marginLeft: "5px" }}>{ProfileData?.speciality}</span>
          </Typography>
          <Typography sx={{ lineHeight: "55px" }}>
            <span style={{ fontWeight: "bold" }}>Email :</span>{" "}
            <span style={{ marginLeft: "5px" }}>{ProfileData?.email_id}</span>
          </Typography>
          <Typography sx={{ lineHeight: "55px" }}>
            <span style={{ fontWeight: "bold" }}>Mobile No.</span>{" "}
            <span style={{ marginLeft: "5px" }}>{ProfileData?.mobile_no}</span>
          </Typography>
          <Typography sx={{ lineHeight: "55px" }}>
            <span style={{ fontWeight: "bold" }}>Experience :</span>{" "}
            <span style={{ marginLeft: "5px" }}>{ProfileData?.experience}</span>
          </Typography>
          <Typography sx={{ lineHeight: "55px" }}>
            <span style={{ fontWeight: "bold" }}>Biography :</span>{" "}
            <span style={{ marginLeft: "5px" }}>{ProfileData?.biography}</span>
          </Typography>
          <Typography sx={{ lineHeight: "55px" }}>
            <span style={{ fontWeight: "bold" }}>Working Time :</span>{" "}
            <span style={{ marginLeft: "5px" }}>
              {ProfileData?.working_time}
            </span>
          </Typography>
          <Typography sx={{ lineHeight: "55px" }}>
            <span style={{ fontWeight: "bold" }}>Location :</span>{" "}
            <span style={{ marginLeft: "5px" }}>
              {ProfileData?.location_url}
            </span>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
